import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as cartActions from '../../actions/cart';
import * as frameActions from '../../actions/frames';
import * as orderActions from '../../actions/orders';
import RentalPage from './RentalPage';

const mapStateToProps = ({
  settings,
  product,
  order,
  frames: {
    availableBlocks,
    blackouts,
    finishAvailableBlocks,
    finishBlackouts,
    finishNonAvailableBlocks,
    finishSelection,
    finishTimeslots,
    frames,
    isFetchingBlocks,
    nonAvailableBlocks,
    timeslots,
    ...framesProps
  },
}) => ({
  order,
  frames,
  finishSelection,
  blackouts: finishSelection ? finishBlackouts : blackouts,
  ...settings,
  ...framesProps,
  availableBlocks: finishSelection ? finishAvailableBlocks : availableBlocks,
  isFetchingBlocks,
  nonAvailableBlocks: finishSelection ? finishNonAvailableBlocks : nonAvailableBlocks,
  timeslots: finishSelection ? finishTimeslots : timeslots,
  timeZone: window.bta.timeZone,
  minDate: product.data.mindate,
  maxDate: product.data.maxdate,
  options: product.data.options,
  variants: product.data.variants,
  productTitle: product.data.title,
  schedule: product.data.schedule,
  capacity: product.data.capacities,
  durations: product.data.durations,
  rangeCountBasis: product.data.range_count_basis,
  // Parse lead_time from string to Number and convert from minutes to days.
  leadTime: +product.data.lead_time / 1440,
  productOptions: product.data.options,
  // Convert lag_time from minutes to days.
  lagTime: product.data.lag_time / 1440,
  locale: window.bta.locale.substr(0, 2),
  maxAvailability: product.maxAvailability,
  locations: product.data.locations,
  resources: product.data.resources,
  minDuration: product.data.min_duration,
  maxDuration: product.data.max_duration,
  additionalDetails: order.additionalDetails,
  onTrigger: window.xprops ? window.xprops.onTrigger : null,
  shopBeginningOfWeek: settings.defaultSetting.shop_beginning_of_week,
  shopCountDays: settings.shop_count_days,
  shopDateFormat: settings.shop_date_format,
  shopDatepickerTimeInterval: settings.shop_datepicker_time_interval,
});

const mapDispatchToProps = (dispatch) => ({
  cartActions: bindActionCreators({ ...cartActions }, dispatch),
  frameActions: bindActionCreators({ ...frameActions }, dispatch),
  orderActions: bindActionCreators({ ...orderActions }, dispatch),
});

const RentalPageConnected = connect(
  mapStateToProps,
  mapDispatchToProps,
)(RentalPage);

export default RentalPageConnected;
